import script from "./KkclashInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./KkclashInfo.vue?vue&type=script&setup=true&lang=js"

import "./KkclashInfo.vue?vue&type=style&index=0&id=2cc23ad0&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc23ad0"]])

export default __exports__